import { TextField as MUITextField } from '@mui/material';
import {
  P6, S4, P4, S3, AR1, AR2, S1,
} from '../../../theme';
import { TTextFieldProps } from '../index';
import { TYPOGRAPHY_BODY1, TYPOGRAPHY_CAPTION } from '../../Typography';
import { mergeSX } from '../../../services/helpers';

interface IBuildSXParams {
  multiline?: boolean;
}

const buildSX = ({ multiline }: IBuildSXParams) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 4,
    backgroundColor: S1,
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: S4,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: 1,
      borderColor: P4,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: P6,
    },
    '&.Mui-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: AR1,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: AR1,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: AR2,
      },
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: S3,
    },
    input: {
      padding: '12px 16px',
    },
    '.MuiInputAdornment-root': {
      paddingRight: 2,
    },
  },
  '& .MuiInputLabel-root': {
    color: S4,
    ...TYPOGRAPHY_BODY1,
    left: '2px',
    top: multiline ? '1px' : '-3px',
    '&.Mui-focused': {
      color: P4,
    },
    '&.Mui-error': {
      color: AR1,
      '&.Mui-focused': {
        color: AR1,
      },
    },
  },
  '& .MuiFormHelperText-root': {
    ...TYPOGRAPHY_CAPTION,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    margin: '0 0 0 16px',
    '&.Mui-error': {
      color: AR1,
    },
  },
  '& legend': {
    marginLeft: '2px',
  },
});

const TextField = (props: TTextFieldProps) => {
  const {
    children,
    helperText: preHelperText,
    sx,
    multiline,
    ...restProps
  } = props;
  const helperText = Array.isArray(preHelperText) ? preHelperText.map((text) => (
    <span key={text}>{text}</span>
  )) : preHelperText;
  return (
    <MUITextField
      helperText={helperText}
      multiline={multiline}
      sx={mergeSX(buildSX({ multiline }), sx)}
      {...restProps}
    >
      {children}
    </MUITextField>
  );
};

export default TextField;
